import { load, type Agent } from '@fingerprintjs/fingerprintjs-pro';

let agentPromise: Promise<Agent> | null = null;

function getAgent(): Promise<Agent> {
    if (!agentPromise) {
        agentPromise = load({
            apiKey: process.env.NEXT_PUBLIC_FINGERPRINT_PUBLIC_KEY as string,
            region: process.env.NEXT_PUBLIC_FINGERPRINT_REGION as 'eu' | 'us' | 'ap',
        });
    }
    return agentPromise;
}

const IDENTIFY_TIMEOUT_MS = 2000;

export async function getFingerprintRequestId(): Promise<string | null> {
    if (!process.env.NEXT_PUBLIC_FINGERPRINT_PUBLIC_KEY) return null;
    try {
        return await Promise.race([
            identify(),
            new Promise<null>((resolve) => setTimeout(() => resolve(null), IDENTIFY_TIMEOUT_MS)),
        ]);
    } catch {
        return null;
    }
}

async function identify(): Promise<string | null> {
    const agent = await getAgent();
    const result = await agent.get();
    return result.requestId ?? null;
}
